import { jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';
import { getDefaultHeight } from '../utils/get-default-height.js';

const HorisontalArrowDropzoneIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.316 15.266",
    height: getDefaultHeight(svgProps, 15.266),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: 1.5,
    children: /*#__PURE__*/jsx("path", {
      d: "M0 10.148h9.556a1 1 0 0 1 1 1v2.37c0 .887 1.066 1.335 1.699.716l6.015-5.886a1 1 0 0 0 0-1.43l-6.015-5.886c-.633-.62-1.7-.17-1.7.715v2.32a1 1 0 0 1-1 1H0"
    })
  });
};

export { HorisontalArrowDropzoneIcon };
//# sourceMappingURL=dropzone.arrow.horisontal.js.map
